import debounce from 'lodash/debounce';
import dynamic from 'next/dynamic';
import EFFlower from '../UI/svg/crowdfunding/EFFlower';
import TopBanner from './components/TopBanner';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfLink from '@elem/ui/ef-link';

const Spec = dynamic(() => import('./components/Spec'), { ssr: true });
const Support = dynamic(() => import('./components/Support'), { ssr: true });
const Bundles = dynamic(() => import('./components/Bundles'), { ssr: true });
const Product = dynamic(() => import('./components/Product'), { ssr: true });

export default function CrowdFundingPC({
    productDetail,
    resProductCatagory,
    supportData,
    nowSysTime,
    crowdfundingTimeline,
    shopifyBtnProps,
    bundlesData,
    bannerData,
    activityId,
    isPreOrder,
    Com,
    showCalculator,
    theme = 'white',
    tabChange = null,
    needEmail = false,
    getShopifyPrice = false,
    hideBundles = false,
}: any) {
    const { useState, useEffect, useRouter, useLang, gtm } = useGlobal();
    const { t } = useLang('shared');
    const { locale, query } = useRouter();
    // 当前tab
    const [activeTab, setActiveTab] = useState(query?.tab || 'product');
    const [bannerSubTitle, setBannerSubTitle] = useState(bannerData?.subTitle || '');
    const [days, setDays] = useState(0);
    const [countdownTime, setCountdownTime] = useState(null);
    const [top, setTop] = useState(0);

    const changeTab = (tab: string) => {
        setActiveTab(tab);
        const lineEl = document.querySelector('.gap') as HTMLElement;
        const productNav = document.querySelector('.crowdfunding-tabs-nav') as HTMLElement;
        const proNavOffH = lineEl?.offsetTop + lineEl?.offsetHeight + productNav?.offsetHeight || 843;
        window.scrollTo({
            top: proNavOffH,
            behavior: 'smooth',
        });
        tabChange && tabChange(tab);
        // gtm.push({
        //     event: 'uaEvent',
        //     event_name: 'pre_order_navigation',
        //     navigation_name: tab,
        // });
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: t(`crowdfunding.tabs.${tab}`),
        });
    };

    useEffect(() => {
        const renderFrostNav = debounce(() => {
            const lineEl = document.querySelector('.gap') as HTMLElement;
            const proNavOffH = lineEl?.offsetTop + lineEl?.offsetHeight || 784;
            const productNav = document.querySelector('.crowdfunding-tabs-nav') as HTMLElement;
            productNav?.classList.toggle('frost', productNav?.offsetTop > proNavOffH);
        }, 100);

        document.addEventListener('scroll', renderFrostNav);
        return () => {
            document.removeEventListener('scroll', renderFrostNav);
        };
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                const bar = document.querySelector('.announcement-bar') as HTMLElement;
                if (bar) {
                    const styles = window.getComputedStyle(bar);
                    const position = styles.position;
                    setTop(Number(position === 'sticky' ? bar?.offsetHeight : 0) || 0);
                }
            }, 3000);
        }
    }, []);

    // useEffect(() => {
    //     if (query?.tab === 'bundles') {
    //         const lineEl = document.querySelector('.gap') as HTMLElement;
    //         const productNav = document.querySelector('.crowdfunding-tabs-nav') as HTMLElement;
    //         const proNavOffH = lineEl?.offsetTop + lineEl?.offsetHeight + productNav?.offsetHeight || 843;
    //         window.scrollTo({
    //             top: proNavOffH,
    //             behavior: 'smooth',
    //         });
    //     }
    // }, [query]);

    return (
        <div className={`crowdFundingPC ${css.crowdfunding}`}>
            {/* // 母亲节促销 @陈琨要求加一个母亲节促销文案, 仅限blade */}
            {bannerData?.note && (
                <div className="top-note">
                    <div className="top-icon">
                        <EFFlower />
                    </div>
                    <div className="top-text">{bannerData?.note}</div>
                    <div className="top-icon">
                        <EFFlower />
                    </div>
                </div>
            )}
            {/* 欧洲6站夏日促销 */}
            {bannerData?.promotion && (
                <div className="top-promotion">
                    <p className="promotion-text">{bannerData?.promotion}</p>
                </div>
            )}
            <TopBanner
                activeTab={activeTab}
                callBack={setActiveTab}
                bannerData={{ ...bannerData, subTitle: bannerSubTitle, days, countdownTime }}
                activityId={activityId}
                isPreOrder={isPreOrder}
                showCalculator={showCalculator}
                hideBundles={hideBundles}
            />
            <div className="gap"></div>
            <div className={`crowdfunding-tabs-nav nav-${activeTab} ${theme}`} style={{ top: `${top}px` }}>
                <div className="nav-wrapper">
                    <span className="product-name">{bannerData?.title || productDetail?.name}</span>
                    <div className="right-tabs">
                        <span className={`tab-item tab-product ${activeTab === 'product' ? 'active' : ''}`} onClick={() => changeTab('product')}>
                            {t('crowdfunding.tabs.product')}
                        </span>
                        {!hideBundles && (
                            <span className={`tab-item tab-bundles ${activeTab === 'bundles' ? 'active' : ''}`} onClick={() => changeTab('bundles')}>
                                {t('crowdfunding.tabs.bundles')}
                            </span>
                        )}
                        <span className={`tab-item tab-specs ${activeTab === 'specs' ? 'active' : ''}`} onClick={() => changeTab('specs')}>
                            {t('crowdfunding.tabs.specs')}
                        </span>
                        <span className={`tab-item tab-support ${activeTab === 'support' ? 'active' : ''}`} onClick={() => changeTab('support')}>
                            {t('crowdfunding.tabs.support')}
                        </span>
                        {productDetail?.buyLink && (
                            <EfLink className="tab-item tab-buy" href={productDetail?.buyLink || ''}>
                                {t('crowdfunding.header.order_now')}
                            </EfLink>
                        )}
                    </div>
                </div>
            </div>
            <div className="crowdfunding-tabs-content">
                <div className={`content-item content-product ${activeTab === 'product' ? 'show' : 'hide'}`}>
                    <Product Com={Com} needEmail={needEmail} />
                </div>
                {!hideBundles && (
                    <div className={`content-item content-bundles ${activeTab === 'bundles' ? 'show' : 'hide'}`}>
                        <Bundles
                            bundlesData={bundlesData}
                            shopifyBtnProps={shopifyBtnProps}
                            crowdfundingTimeline={crowdfundingTimeline}
                            nowSysTime={nowSysTime}
                            activeTab={activeTab}
                            activityId={activityId}
                            callbackSubtitle={setBannerSubTitle}
                            callbackDays={setDays}
                            days={bannerData?.days}
                            callbackCountdown={setCountdownTime}
                            topCountdown={bannerData?.showCountdown}
                            getShopifyPrice={getShopifyPrice}
                        />
                    </div>
                )}
                <div className={`content-item content-specs ${activeTab === 'specs' ? 'show' : 'hide'}`}>
                    <Spec productDetail={productDetail} resProductCatagory={resProductCatagory} />
                </div>
                <div className={`content-item content-support ${activeTab === 'support' ? 'show' : 'hide'}`}>
                    <Support supportData={supportData} />
                </div>
            </div>
        </div>
    );
}
